import { render, staticRenderFns } from "./HomeSwiper.vue?vue&type=template&id=6500c632"
import script from "./HomeSwiper.vue?vue&type=script&lang=js"
export * from "./HomeSwiper.vue?vue&type=script&lang=js"
import style0 from "./HomeSwiper.vue?vue&type=style&index=0&id=6500c632&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports